/* eslint react/destructuring-assignment:0 */
/* eslint react/jsx-filename-extension:0 */
/* eslint react/no-did-update-set-state:0 */
/* eslint no-underscore-dangle:0 */
/* eslint react/no-did-update-set-state:0 */
/* eslint react/no-access-state-in-setstate:0 */
/* eslint jsx-a11y/click-events-have-key-events:0 */
/* eslint react/state-in-constructor:0 */

import React, { Fragment, Component } from 'react';

import debounce from 'lodash/debounce';
import {
    COMMAND,
    KEYCODE,
    KEY,
} from '../../utilities/CONSTANTS';

class Suggestion extends Component {
    componentDidMount() {
        this.node.addEventListener('mousedown', this.selectSuggestion, false);
    }

    componentWillUnmount() {
        this.node.removeEventListener('mousedown', this.selectSuggestion, false);
    }

    selectSuggestion = () => {
        this.props.selectSuggestion(this.props.suggestion);
    }

    render() {
        const { className, suggestion, renderSuggestion } = this.props;
        return (
            <div
                ref={(node) => { this.node = node; }}
                className={className}
            >
                {renderSuggestion(suggestion)}
            </div>
        );
    }
}

/*
 * Suggestions Component
 *
 * @param getSuggestions: (searchText:string) => Promise | Array
 * @param selectSuggestion: (Suggestion) => void
 * @param async: boolean
 * @param editorState: EditorState
 * @param addKeyBindingCallback: Function
 * @param removeKeyBindingCallback: Function
 * @param searchText: string
 *
 * @returns React.Node
 */

class Suggestions extends Component {
    static defaultProps = {
        searchText: '',
        isSearching: false,
        renderSuggestion: suggestion => (
            <Fragment>
                <img className="suggestion-icon" src={suggestion.image_192} alt="thumbnail" height="20" width="20" />
                <div className="suggestion-title">{suggestion.display_name}</div>
            </Fragment>
        ),
    }

    constructor(props) {
        super(props);

        if (props.async === true) {
            this.setSuggestions = debounce(this.setSuggestions, 300);
        }
    }

    state = {
        suggestions: [],
        focusedSuggestion: 0,
    }

    componentDidMount() {
        this._isMounted = true;
        this.setState({ isSearching: true });
        this.setSuggestions();
        this.props.addKeyBindingCallback(this.keydownHandler);
        document.body.addEventListener('click', this.clickHandler);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.searchText !== this.props.searchText) {
            this.setState({ isSearching: true });
            this.setSuggestions();
        }
    }

    componentWillUnmount() {
        this.deactivateSuggestions();
        this._isMounted = false;
    }

    setSuggestions = () => {
        const result = this.props.getSuggestions(this.props.searchText);
        if (result.then != null && this._isMounted === true) {
            this.setState({ isSearching: true });
            result.then((suggestions) => {
                this.setState({ suggestions, isSearching: false });
            });
        } else if (this._isMounted === true) {
            this.setState({ suggestions: result, isSearching: false });
        }
    }

    deactivateSuggestions = () => {
        this.props.removeKeyBindingCallback(this.keydownHandler);
        document.body.removeEventListener('click', this.clickHandler);
    };

    clickHandler = () => this.deactivateSuggestions();

    keydownHandler = (e) => {
        const { suggestions } = this.state;
        if ([KEY.enter, KEY.tab].includes(e.key)) {
            e.stopPropagation();
            e.preventDefault();
            if (suggestions.length > 0) {
                this.props.selectSuggestion(suggestions[this.state.focusedSuggestion]);
            }
            return COMMAND.insertSuggestion;
        } if (e.which === KEYCODE.downArrow) {
            e.stopPropagation();
            e.preventDefault();
            let focusedSuggestion = this.state.focusedSuggestion + 1;
            focusedSuggestion = focusedSuggestion === suggestions.length ? focusedSuggestion - 1 : focusedSuggestion;
            this.setState({ focusedSuggestion });
        } else if (e.which === KEYCODE.upArrow) {
            e.stopPropagation();
            e.preventDefault();
            let focusedSuggestion = this.state.focusedSuggestion - 1;
            focusedSuggestion = focusedSuggestion < 0 ? 0 : focusedSuggestion;
            this.setState({ focusedSuggestion });
        } else if (e.which === KEYCODE.escape
            || e.which === KEYCODE.leftArrow
            || e.which === KEYCODE.rightArrow
            || e.which === KEYCODE.tab
            || e.which === KEYCODE.space
        ) {
            this.deactivateSuggestions();
        }
        return null;
    };

    selectSuggestion = (suggestion) => {
        this.deactivateSuggestions();
        if (suggestion) {
            this.props.selectSuggestion(suggestion);
        }
    };

    render() {
        const { suggestions, isSearching } = this.state;

        if (isSearching === true) {
            return (<div>Searching...</div>);
        } if (!isSearching && suggestions.length === 0) {
            return (<div onClick={this.deactivateSuggestions}>No results found</div>);
        }

        return suggestions.map((suggestion, index) => (
            <Suggestion
                selectSuggestion={this.selectSuggestion}
                renderSuggestion={this.props.renderSuggestion}
                className={this.state.focusedSuggestion === index ? 'focused' : ''}
                suggestion={suggestion}
                key={suggestion.id || suggestion.slack_id || suggestion.getId()}
            />
        ));
    }
}

export default Suggestions;
